export enum ETicketType {
  Subscription = 'Subscription',
  Direct = 'Direct-Ticket',
  Relation = 'Relation-Ticket',
  All = 'Alle',
}
